module.exports = __webpack_public_path__ + "img/guideOne.4e7f835c.png";